import { Box, makeStyles } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilState } from "recoil";

import { CustomButton } from "@/components/Button";
import {
  RegistrationActions,
  RegistrationBack,
  RegistrationSection,
} from "@/components/property_registration/RegistrationActions";
import { CustomForm } from "@/components/property_registration/RegistrationInputs";
import { Toast } from "@/components/Toast";
import theme from "@/theme";
import { PropertyRegistrationState } from "@/view_models/atoms";

const useStyles = makeStyles(() => ({
  content: {
    width: 640,
    [theme.breakpoints.down("sm")]: {
      width: 342,
    },
    margin: "8px  auto 0px auto",
  },
  block: {
    marginBottom: 24,
  },
  blockTitle: {
    color: theme.palette.text.primary,
    marginBottom: 8,
  },
  formBlock: {
    backgroundColor: theme.palette.background.default,
    padding: "8px 16px",
    borderRadius: 8,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      borderBottom: "none",
    },
  },
}));

interface AddNewOwnBuildingPropertyCostPageProps {
  onBack: () => void;
  validate: () => Promise<boolean>;
}

export const prefecture_unselected = "";

const AddNewOwnBuildingPropertyCostPage: React.FC<AddNewOwnBuildingPropertyCostPageProps> = ({ onBack, validate }) => {
  const classes = useStyles();
  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext();
  const [formData] = useRecoilState(PropertyRegistrationState);
  // サーバーエラー
  const [serverError, setSeverError] = useState<string>("");

  const handleNext = async () => {
    const isValid = await validate();
    const data = getValues();
    if (isValid) {
      console.log("isValid in cost");
      console.log(data);
    }
  };

  const handleClose = useCallback(() => {
    setSeverError("");
  }, []);

  // 選択肢
  return (
    <>
      <Box>
        <Box className={classes.content} data-registration-content>
          <RegistrationSection title="毎月の経費" />
          <Box className={classes.block}>
            <Controller
              name="management_company_commission"
              control={control}
              defaultValue={formData.management_company_commission || ""}
              render={({ ...field }) => (
                <CustomForm
                  {...field}
                  label="管理会社委託費（建物＋賃貸管理含む）"
                  error={!!errors.management_company_commission}
                  errorText={errors.management_company_commission?.message}
                  onChange={field.onChange}
                  placeHolder="100,000,000"
                  unitSuffix="円"
                  formatNumeric
                />
              )}
            />
            <Controller
              name="shared_utility_expenses"
              control={control}
              defaultValue={formData.shared_utility_expenses || ""}
              render={({ ...field }) => (
                <CustomForm
                  {...field}
                  label="共用部水道光熱費"
                  error={!!errors.shared_utility_expenses}
                  errorText={errors.shared_utility_expenses?.message}
                  onChange={field.onChange}
                  placeHolder="100,000,000"
                  unitSuffix="円"
                  formatNumeric
                />
              )}
            />
            <Controller
              name="misc_building_cost"
              control={control}
              defaultValue={formData.misc_building_cost || ""}
              render={({ ...field }) => (
                <CustomForm
                  {...field}
                  label="その他経費"
                  error={!!errors.misc_building_cost}
                  errorText={errors.misc_building_cost?.message}
                  onChange={field.onChange}
                  placeHolder="100,000,000"
                  unitSuffix="円"
                  formatNumeric
                />
              )}
            />
          </Box>{" "}
          <RegistrationSection title="売却" />
          <Controller
            name="asking_price"
            control={control}
            defaultValue={formData.asking_price || ""}
            render={({ ...field }) => (
              <CustomForm
                {...field}
                label="希望売却価格(あれば)"
                error={!!errors.asking_price}
                errorText={errors.asking_price?.message}
                onChange={field.onChange}
                placeHolder="100,000,000"
                unitSuffix="円"
                formatNumeric
              />
            )}
          />
        </Box>
        <RegistrationActions>
          <CustomButton type="submit" customVariant="filled" onClick={handleNext}>
            登録する
          </CustomButton>
          <RegistrationBack onClick={onBack} />
        </RegistrationActions>
      </Box>
      <Toast open={!!serverError} variant="error" message={serverError} onClose={handleClose} />
    </>
  );
};

export default AddNewOwnBuildingPropertyCostPage;
